// src/pages/Login/index.jsx
import React from "react";
import { SignIn } from "@clerk/clerk-react";
import logo from "../../assets/images/logo.png";
import { SocialLinks } from "../../components";

export default function Login() {
  return (
    <div className="min-h-screen star-background bg-neutral-950 w-full flex relative">
      <div className="flex-1 min-h-screen flex flex-col relative">


        {/* Sign in block */}
        <div className="flex-1 flex z-40 items-center justify-center px-4 sm:px-6 lg:px-8 pt-24 md:pt-0">
          <SignIn
            appearance={{
              elements: {
                footerAction: { display: "none" },
                footerActionLink: { display: "none" },
              },
            }}
          />

        </div>

        {/* Mobile footer */}
        <div className="w-full  pb-6">
          <div className="flex justify-center flex-col gap-3 items-center">
            <SocialLinks />
            <p className="text-neutral-700 text-xs">© {new Date().getFullYear()} Weberz, Inc. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}